import type React from "react";
import { Link } from "react-router";
import { useEffect, useState } from "react";
import { api } from "../../api";
import { Button } from "@/components/ui/button";
import type { Workflow } from "@butler/shared";
import { Card, CardContent, CardHeader } from "../ui/card";
import { Separator } from "../ui/separator";

const ChatHistory: React.FC = () => {
  return (
    <div className="p-20 gap-5 flex flex-col items-center justify-center min-h-[80vh] text-primary">
      <h1 className="text-5xl font-bold mb-8">Conversations</h1>
      <p className="text-xl text-center mb-12 max-w-2xl dark:text-gray-300">
        Continue where you left off.
      </p>
      <div className="p-20 gap-5 flex flex-col items-center justify-center min-h-[80vh] text-primary">
        <ChatHistoryList />
      </div>
    </div>
  );
};

export const ChatHistoryList: React.FC = () => {
  const [workflows, setWorkflows] = useState<Workflow[]>([]);
  useEffect(() => {
    const fetchWorkflows = async () => {
      const { data, error } = await api.workflows.get();
      if (error) {
        console.error(error);
      } else {
        setWorkflows(data || []);
      }
    };
    fetchWorkflows();
  }, []);
  return (
    <>
      {workflows.map((workflow) => (
        <Link to={`${workflow.ID}/chat`} key={workflow.ID}>
          <Card
            key={workflow.ID}
            className="w-sm h-40 hover:shadow-lg hover:translate-y-[-2px] transition-all duration-300 hover:bg-blue-200"
          >
            <CardHeader className="text-lg font-semibold">
              {workflow.name}
            </CardHeader>
            <CardContent>
              <p>{workflow.current_stage}</p>
              <p>{workflow.codePath}</p>
            </CardContent>
          </Card>
        </Link>
      ))}
    </>
  );
};

export default ChatHistory;
